// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"50a76b92","675":"aff043b4"}[chunkId] + ".chunk.js";
};